var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonFrecciaSx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button_freccia_sx",
    transform: "translate(-1284 -1172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    transform: "translate(1284 1172)",
    fill: "none",
    stroke: "#2e363a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18",
    "data-name": "Raggruppa 18",
    transform: "translate(1305.268 1205.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H37.464",
    transform: "translate(0 6.74)",
    fill: "none",
    stroke: "#ca3625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.74,13.48,0,6.74,6.74,0",
    transform: "translate(0.008 0)",
    fill: "none",
    stroke: "#ca3625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFrecciaSx);
export default __webpack_public_path__ + "static/media/button_freccia_sx.813dd30560416ebe41b9a2e2d02b52dd.svg";
export { ForwardRef as ReactComponent };